import React from 'react';
import {useTranslation} from "react-i18next";
import {cn} from "../utils/style";

const CardPreview = ({cardNumber, cardHolder, expiry, cardType}) => {
    const {t} = useTranslation();

    const getCardBg = () => {
        switch (cardType) {
            case 'visa':
                return 'from-blue-600 to-blue-800';
            case 'mastercard':
                return 'from-red-500 to-orange-600';
            case 'amex':
                return 'from-emerald-500 to-teal-700';
            default:
                return 'from-gray-700 to-gray-900';
        }
    };

    return (
        <div className={cn(
            "relative w-full aspect-[1.586/1] rounded-xl p-6 text-white shadow-xl transition-all duration-500 bg-gradient-to-br flex flex-col justify-between",
            getCardBg()
        )}>
            <div className="flex justify-between items-start">
                <div className="w-12 h-8 bg-yellow-400/80 rounded-md shadow-inner flex items-center justify-center">
                    <div className="w-8 h-6 border border-yellow-600/30 rounded" />
                </div>
                {cardType !== 'unknown' && (
                    <span className="text-xl font-bold uppercase tracking-wider">{cardType}</span>
                )}
            </div>

            <div className="mt-auto mb-6">
                <div className="text-xs opacity-70 mb-1.5 uppercase tracking-tighter">{t('card.number')}</div>
                <div className="text-xl font-mono tracking-widest leading-none h-6 flex items-center">
                    {cardNumber || '•••• •••• •••• ••••'}
                </div>
            </div>

            <div className="flex justify-between items-end">
                <div className="flex-1">
                    <div className="text-[10px] opacity-70 uppercase mb-1">{t('card.holder_name')}</div>
                    <div className="text-sm font-medium uppercase truncate max-w-[150px] h-5">
                        {cardHolder || 'FULL NAME'}
                    </div>
                </div>
                <div className="text-right">
                    <div className="text-[10px] opacity-70 uppercase mb-1">{t('card.expiry')}</div>
                    <div className="text-sm font-medium h-5">
                        {expiry || 'MM/YY'}
                    </div>
                </div>
            </div>

            <div className="absolute inset-0 pointer-events-none opacity-10 overflow-hidden rounded-xl">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
                            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.5" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#grid)" />
                </svg>
            </div>
        </div>
    );
};

export default CardPreview;
